import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, BadgePercent } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../auth";
import { useLang } from "../i18n";
import { Shell } from "../layout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const slots = ["10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00"];

export default function Book() {
  const { user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const today = new Date().toISOString().slice(0, 10);
  const options = t("service.options");
  const [form, setForm] = useState({ service: options[0], date: "", time: "10:00", car: "", notes: "" });
  const [sent, setSent] = useState(false);
  const discountEligible = localStorage.getItem("nnm_discount") === "eligible";

  useEffect(() => {
    if (user === false) return navigate("/login");
    if (user) setForm(f => ({ ...f, car: f.car || user.car || "" }));
  }, [user, navigate]);

  useEffect(() => {
    setForm(f => (options.includes(f.service) ? f : { ...f, service: options[0] }));
  }, [t]);

  const submit = async (e) => {
    e.preventDefault();
    const body = { ...form };
    if (discountEligible) body.discount = "FIRST15";
    const r = await fetch(`${API}/appointments`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
    if (!r.ok) return toast.error(t("book.err"));
    if (discountEligible) localStorage.setItem("nnm_discount", "used");
    setSent(true);
    toast.success(t("book.toastOk"));
  };

  return (
    <Shell>
      <main className="page">
        <section className="page-hero">
          <p className="eyebrow">{t("book.eyebrow")}</p>
          <h1>{t("book.titleA")}<br /><em>{t("book.titleB")}</em></h1>
          <p>{t("book.copy")}</p>
        </section>
        <section className="contact-grid section">
          <div className="contact-info">
            <p className="eyebrow">{t("book.howEyebrow")}</p>
            <div className="info-item"><span className="row-num">01</span><span>{t("book.step1")}</span></div>
            <div className="info-item"><span className="row-num">02</span><span>{t("book.step2")}</span></div>
            <div className="info-item"><span className="row-num">03</span><span>{t("book.step3")}</span></div>
          </div>
          <div className="form-panel">
            {sent ? (
              <div className="success-state" data-testid="booking-success-message">
                <span>✓</span>
                <h2>{t("book.successTitle")}</h2>
                <p>{t("book.successCopy")}</p>
                <button className="button button-outline" onClick={() => navigate("/account")} data-testid="booking-view-account-button">{t("book.viewGarage")}</button>
              </div>
            ) : (
              <form onSubmit={submit} data-testid="booking-form">
                <p className="eyebrow">{t("book.formEyebrow")}</p>
                <label>{t("book.service")}
                  <select value={form.service} onChange={e => setForm({ ...form, service: e.target.value })} data-testid="booking-service-select">
                    {options.map(o => <option key={o}>{o}</option>)}
                  </select>
                </label>
                <div className="form-grid">
                  <label>{t("book.date")}<input type="date" required min={today} value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} data-testid="booking-date-input" /></label>
                  <label>{t("book.time")}
                    <select value={form.time} onChange={e => setForm({ ...form, time: e.target.value })} data-testid="booking-time-select">
                      {slots.map(s => <option key={s}>{s}</option>)}
                    </select>
                  </label>
                </div>
                <label>{t("book.car")} <span>{t("book.carOpt")}</span><input value={form.car} onChange={e => setForm({ ...form, car: e.target.value })} placeholder="BMW 320d (2019)" data-testid="booking-car-input" /></label>
                <label>{t("book.notes")} <span>{t("book.notesOpt")}</span><textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} data-testid="booking-notes-input" /></label>
                {discountEligible && <p className="discount-note" data-testid="booking-discount-note"><BadgePercent size={15} /> {t("contact.discountNote")}</p>}
                <button type="submit" className="button button-red full" data-testid="booking-submit-button">{t("book.submit")} <ArrowUpRight size={18} /></button>
              </form>
            )}
          </div>
        </section>
      </main>
    </Shell>
  );
}
